import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Button } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

import logo from './img/logo.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'elcuatro';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-elcuatro-container">
        <img src={logo} alt="logo" className="logo-elcuatro" />
        <h1 className="t2-elcuatro">{translate("Title")}</h1>
        <h5 className="t3-elcuatro">{translate("Title2")}</h5>
        <Form onSubmit={(event) => onSubmit(event)}>
          <label className="elcuatro-label">
            <span id="label-username">{translate("PlaceholderUserName")}</span>
            <Input
              className="elcuatro-input"
              disabled={onLogin}
              required={true}
              tabIndex={1}
              type="email"
              autoCorrect="off"
              autoCapitalize="none"
              id="elcuatro-username"
              onChange={e => setUsername(e.target.value)}
            />
            <div className="border-focus"></div>
          </label>
          <label className="elcuatro-label">
            <span id="label-password">{translate("PlaceholderPassword")}</span>
            <Input
              className="elcuatro-input"
              required={true}
              disabled={onLogin}
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="elcuatro-password"
              onChange={e => setPassword(e.target.value)}
            />
            <div className="border-focus"></div>
          </label>
          <p className="remember-pass-elcuatro">
            <a href="https://ott.elcuatro.com/registro/recuperar" target="_blank" rel="noopener noreferrer">¿Olvidó su clave?</a>
          </p>
          <Button
            block={!parameters.failureRedirect}
            tabIndex={1}
            type="submit"
            id="submmit"
            className="enter-elcuatro elcuatro-btn"
            disabled={onLogin || !props.turnstileSuccess}
          >
            {translate("ButtonEnter")}
          </Button>
          {onLogin && <Progress animated color="danger" value={100} />}
          <div className="messages-container">
            <Alert
              color="danger"
              id="error-message"
              isOpen={error.open}
              toggle={() => setError({ open: false })}
            >
              {error.message}
            </Alert>
          </div>
          <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true });
